import React, { ChangeEvent } from 'react'

interface PasswordInputProps {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  showPassword: boolean
  onTogglePassword: () => void
}

const PasswordInput = ({ value, onChange, showPassword, onTogglePassword }: PasswordInputProps): JSX.Element => {
  return (
    <div
      className="self-stretch h-11 bg-white rounded-md inline-flex justify-center items-center"
      style={{
        boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
      }}>
      <div className="flex-1 self-stretch px-4 py-1.5 flex justify-center items-center gap-2">
        <input
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          className="flex-1 justify-start outline-none bg-transparent text-gray-900 text-xs font-medium font-Montserrat leading-5"
          placeholder=""
        />
      </div>
      <div className="w-px self-stretch bg-gray-300" />
      <button
        type="button"
        onClick={onTogglePassword}
        className="p-4 bg-transparent rounded-md flex justify-center items-center overflow-hidden hover:bg-gray-100 transition-colors">
        <div className="w-3.5 h-3.5 relative overflow-hidden">
          {showPassword ? (
            <svg className="w-3.5 h-3.5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={
                  'M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029' +
                  'm5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29' +
                  'M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21'
                }
              />
            </svg>
          ) : (
            <svg className="w-3.5 h-3.5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          )}
        </div>
      </button>
    </div>
  )
}

export default PasswordInput
